import React, { useState, useEffect } from "react";
import AppDataTable from "./AppDataTable";
import { getAllSubcriptionPlain } from "../../interpreter/subcription";
import Icon from "@mdi/react";
import { mdiCardAccountDetailsOutline, mdiCancel } from "@mdi/js";
import "./AppDataTable.css";

const getStatusBadge = (status) => {
  const active = status === "1";
  return (
    <span className={`table-badge ${active ? "table-badge--active" : "table-badge--muted"}`}>
      {active ? "Activo" : "Inactivo"}
    </span>
  );
};

export const SubscriptionList = ({ setSubscriptions, subscriptions, openModal }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        setLoading(true);
        const data = await getAllSubcriptionPlain();
        if (Array.isArray(data) && data.length > 0) {
          setSubscriptions(data);
        } else {
          setSubscriptions([]);
        }
      } catch (error) {
        console.error("Error al obtener las suscripciones:", error);
        setSubscriptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, [setSubscriptions]);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      center: true,
      width: "70px",
      minWidth: "60px",
    },
    {
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
      center: true,
      wrap: true,
      grow: 2,
      minWidth: "120px",
    },
    {
      name: "Código",
      selector: (row) => row.codeSubcription ?? "N/A",
      sortable: true,
      center: true,
      wrap: true,
      minWidth: "90px",
    },
    {
      name: "Precio",
      selector: (row) => (row.price ? `Bs${row.price}` : "N/A"),
      sortable: true,
      center: true,
      minWidth: "80px",
    },
    {
      name: "Estado",
      cell: (row) => getStatusBadge(row.status),
      sortable: true,
      center: true,
      minWidth: "90px",
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="table-actions table-actions--stack-sm">
          <button
            type="button"
            onClick={() => openModal("detail", row.id)}
            className="table-action table-action--labeled table-action--primary"
            title="Ver detalle del plan"
          >
            <Icon path={mdiCardAccountDetailsOutline} size={0.95} />
            <span className="table-action__label">Ver detalle</span>
          </button>
          <button
            type="button"
            onClick={() => openModal("annular", row.id)}
            className="table-action table-action--labeled table-action--danger"
            title="Anular suscripción"
          >
            <Icon path={mdiCancel} size={0.95} />
            <span className="table-action__label">Anular</span>
          </button>
        </div>
      ),
      center: true,
      minWidth: "200px",
      grow: 1,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div>
      {loading ? (
        <div className="table-loading">
          <div className="table-loading__spinner" role="status" aria-label="Cargando suscripciones" />
        </div>
      ) : (
        <AppDataTable
          columns={columns}
          data={Array.isArray(subscriptions) ? subscriptions : []}
          noDataComponent={<p className="table-empty">No hay suscripciones disponibles.</p>}
        />
      )}
    </div>
  );
};
